module.exports = __webpack_public_path__ + "img/ip-img1.3d77842b.png";